import moment from 'moment'

export default function (value, na='') {
  // 15:32 => 03:32 pm (military => US)
  return value && value !== '' ? moment('2020-01-27 ' + value).format('hh:mm a') : na
}
